import { render, staticRenderFns } from "./UserInputsDiscount.vue?vue&type=template&id=205a4a11&"
import script from "./UserInputsDiscount.vue?vue&type=script&lang=js&"
export * from "./UserInputsDiscount.vue?vue&type=script&lang=js&"
import style0 from "./UserInputsDiscount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports